export const LOGO_PATH = {
  light: '/logo-duotone.svg',
  dark: '/logo-white.svg',
};

export const LOGO_ALT_TEXT = 'logo';
